import axios from '@/utils/request';

export const getExam = (data, header, options) => {
  return axios.post('/api/hxt/paper/getExam', data, header, options)
}

export const createUserPaperTest = (data, header, options) => {
  return axios.post('/api/hxt/paper/createUserPaperTest', data, header, options)
}

export const paperDetailExam = (data, header, options) => {
  return axios.post('/api/hxt/paper/paper-detail-exam', data, header, options)
}

export const quDetailExercise = (data, header, options) => {
  return axios.post('/api/hxt/paper/qu-detail-exercise', data, header, options)
}

export const fillAnswers = (data, header, options) => {
  return axios.post('/api/hxt/paper/fill-answer-exam', data, header, options)
}

export const handExam = (data, header, options) => {
  return axios.post('/api/hxt/paper/hand-exam', data, header, options)
}

export const getExamTestResult = (data, header, options) => {
  return axios.post('/api/hxt/paper/getExamTestResult', data, header, options)
}

export const getExamMnResult = (data, header, options) => {
  return axios.post('/api/hxt/paper/getExamMnResult', data, header, options)
}
